import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const peopleProfilesRoute: InvariantJiraRoute = {
	name: 'people-index',
	path: '/jira/people/:subPath?',
};
